import { ISelectMiniOption } from '@salecycle/ui-component-library';
import { TFunction } from 'i18next';
import { ComparisonType, DashboardDateRange } from '../entities';

export const DATE_DISPLAY_FORMAT = "DD MMM 'YY";

export const DateRangeOptions = (t: TFunction): ISelectMiniOption[] => [
  { value: String(DashboardDateRange.TODAY), label: t('dashboard:dateRange.today') },
  { value: String(DashboardDateRange.YESTERDAY), label: t('dashboard:dateRange.yesterday') },
  { value: String(DashboardDateRange.LAST_SEVEN_DAYS), label: t('dashboard:dateRange.lastSevenDays') },
  { value: String(DashboardDateRange.LAST_THIRTY_DAYS), label: t('dashboard:dateRange.lastThirtyDays') },
  { value: String(DashboardDateRange.LAST_NINETY_DAYS), label: t('dashboard:dateRange.lastNinetyDays') },
  { value: String(DashboardDateRange.LAST_YEAR), label: t('dashboard:dateRange.lastYear') },
  { value: 'custom', label: t('dateRange.custom') },
];

export const ComparisonTypeOptions = (t: TFunction): ISelectMiniOption[] => [
  { value: ComparisonType.NONE, label: t('dashboard:dates.comparison.types.none') },
  { value: ComparisonType.YEAR, label: t('dashboard:dates.comparison.types.year') },
  { value: ComparisonType.PERIOD, label: t('dashboard:dates.comparison.types.period') },
  { value: ComparisonType.CUSTOM, label: t('dashboard:dates.comparison.types.custom') },
];
